import { makeStyles } from '@material-ui/core'

export const useDesignationFieldStyles = makeStyles(() => ({
    container: {
        marginLeft: 4,
        position: 'relative',
        display: 'inline-block',
    },
    content: {
        transition: 'opacity 0.15s ease-in-out',
    },
    contentVisible: {
        opacity: 1,
    },
    contentHidden: {
        opacity: 0,
        pointerEvents: 'none',
    },
    skeleton: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '85%',
        borderRadius: 4,
    },
    // Matches ReplacementOption's disabledBoxedInputContainer styling (Bug 2593702)
    inactiveText: {
        textDecoration: 'line-through',
        textDecorationColor: 'rgba(0,0,0,0.5)',
        color: 'rgba(0,0,0,0.5)',
    },
}))
